/** Display helpers. Business dates and times are shown in America/Chicago. */
const TZ = "America/Chicago";

const dateFmt = new Intl.DateTimeFormat("en-US", { timeZone: TZ, month: "short", day: "numeric", year: "numeric" });
const dateTimeFmt = new Intl.DateTimeFormat("en-US", {
  timeZone: TZ, month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit",
});
const moneyFmt = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });

export function date(v: string | null | undefined): string {
  return v ? dateFmt.format(new Date(v)) : "";
}

export function dateTime(v: string | null | undefined): string {
  return v ? dateTimeFmt.format(new Date(v)) : "";
}

/** 'YYYY-MM-DD' (a date with no time zone) → "May 4, 2026". */
export function dayOnly(v: string | null | undefined): string {
  if (!v) return "";
  const [y, m, d] = v.slice(0, 10).split("-").map(Number);
  return dateFmt.format(new Date(Date.UTC(y!, m! - 1, d!, 12)));
}

export function money(v: string | number | null | undefined): string {
  if (v == null || v === "") return "";
  const n = Number(v);
  return Number.isFinite(n) ? moneyFmt.format(n) : "";
}

/** 6085551234 → (608) 555-1234; anything else unchanged. */
export function phone(v: string | null | undefined): string {
  const d = (v ?? "").replace(/\D/g, "");
  if (d.length === 10) return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
  if (d.length === 11 && d.startsWith("1")) return `(${d.slice(1, 4)}) ${d.slice(4, 7)}-${d.slice(7)}`;
  return v ?? "";
}

/** Line total: quantity × price − discount. */
/** Line total: quantity × (price − discount), as the old portal and invoice count it. */
export function lineTotal(i: { quantity: number; price: string; discount?: string | null }): number {
  return i.quantity * (Number(i.price) - Number(i.discount ?? 0));
}

export function trackingUrl(carrier: string, tracking: string): string | null {
  const c = carrier.toUpperCase();
  if (c.includes("USPS")) return `https://tools.usps.com/go/TrackConfirmAction?tLabels=${encodeURIComponent(tracking)}`;
  if (c.includes("UPS")) return `https://www.ups.com/track?tracknum=${encodeURIComponent(tracking)}`;
  return null;
}
